// Keys ougt to be sorted alphabetically, case sensitive.	Frans
// To autosort: repeat CTRL+S until all keys are sorted
//  OR
// repeat command until sorted: npm run lint-fix

/* eslint sort-keys-fix/sort-keys-fix: error */
export default {
  accesslog: {
    accessedAt: 'Datum tijd',
    accessedBy: 'Geopend door',
    accessedResource: 'Gebruikte bron',
    ip: 'IP',
    parameters: 'Parameters'
  },
  ban: {
    bannedAtUtc: 'Verbannen op (UTC)',
    bannedUntilUtc: 'Verbannen tot (UTC)'
  },
  common: {
    active: 'Actief',
    add: 'Toevoegen',
    address: 'Adres',
    addressee: 'Geadresseerde',
    back: 'Terug',
    bankAccountBIC: 'BIC',
    bankName: 'Bank',
    barcodePrefix: 'Barcode voorloopnummer',
    barcodeType: 'Type barcode',
    bdo: 'BDO',
    billingAddress: 'Factuuradres',
    billingEmail: 'Factuur E-mailadres',
    block_notification_not_saved_warning: 'Notificatie instelling niet opgeslagen. Probeer het later opnieuw',
    browserNotSupported: 'Uw browser ondersteunt deze functionaliteit niet',
    businessRegisterNumber: 'KvK-nummer',
    cancel: 'Annuleren',
    city: 'Plaats',
    clearFilters: 'Verwijder alle filters',
    close: 'Sluiten',
    close_unsaved_warning: 'Uw wijzigingen zijn nog niet opgeslagen. Weet u zeker dat u dit scherm wilt sluiten?',
    code: 'Code',
    company: 'Bedrijf',
    companyAddress: 'Bezoekadres',
    companyEmail: 'E-mailadres',
    confirm: 'Bevestigen',
    continue: 'Doorgaan',
    copyToClipboard: 'Kopiëer naar klembord',
    copyToClipboardFail: 'Kopiëren naar klembord mislukt',
    copyToClipboardSuccess: 'Kopiëren naar klembord gelukt',
    country: 'Land',
    createReport: 'Maak overzicht',
    creditorNumber: 'Creditor number',
    currency: 'Valuta',
    data_created: 'De gegevens zijn opgeslagen',
    data_save_error: 'De gegevens kunnen niet worden opgeslagen',
    data_updated: 'De wijzigingen zijn opgeslagen',
    date: 'Datum',
    debtorNumber: 'Debiteurennummer',
    decimals: 'Decimalen',
    defaultBottomFinishID: 'Standaard onderzoom',
    defaultBottomFinishMeasurementInCm: 'Standaardmaat onderzoom (cm)',
    defaultEmbraceFinishID: 'Standaard embrasse',
    defaultSideFinishID: 'Standaard zijzoom',
    defaultSideFinishMeasurementInCm: 'Standaardmaat zijzoom (cm)',
    defaultTopFinishID: 'Standaard bovenafwerking',
    defaultTopFinishMeasurementInCm: 'Standaardmaat bovenafwerking (cm)',
    delete: 'Verwijder',
    deletePlural: 'Verwijderen',
    delete_cancelled: 'Verwijderen geannuleerd',
    delete_completed: 'De gegevens zijn verwijderd',
    delete_record_summary_warning: 'Weet u zeker dat u <b>{summary}</b> wilt verwijderen?',
    delete_record_warning: 'Weet u zeker dat u dit wilt verwijderen?',
    department: 'Afdeling',
    description: 'La description',
    domain: 'Domaine',
    domains: 'Domaines',
    dontSave: 'Niet opslaan',
    dontSend: 'Niet verzenden',
    dont_show_again_warning: 'Niet meer tonen',
    downloadExcel: 'Download Excel',
    downloadPDF: 'Download PDF',
    draft: 'Concept',
    ean: 'EAN-13',
    edit: 'Bewerk',
    email: 'Adresse e-mail',
    emptyString: ' ',
    endDate: 'Einddatum',
    error: 'Fout',
    exactInstance: 'Exact',
    excludedFinishes: 'Niet mogelijke afwerkingen',
    export: 'Export',
    fabricProduct: 'Type de tissu',
    fabricType: 'Type de tissu',
    fabricWidth: 'Stofbreedte',
    fax: 'Fax',
    fillInANumber: 'Vul een getal in',
    finish: 'Afwerking',
    finishType: 'Afwerkingssoort',
    finishes: 'Afwerkingen',
    firstName: 'Voornaam',
    fixedPhone: 'Vaste telefoon',
    from: 'van',
    gender: 'Geslacht',
    glAccountNumber: 'Grootboeknummer',
    glAccountNumbers: 'Grootboeknummers',
    iban: 'IBAN',
    id: 'ID',
    inactive: 'Inactief',
    initials: 'Initialen',
    invoiceAddress: 'Factuuradres',
    ipAddress: 'IP-adres',
    jobFunction: 'Functie',
    key: 'Key',
    label: 'Label',
    lastName: 'Achternaam',
    leave_mail_warning: 'U verlaat deze pagina. Wilt u eerst deze mail verzenden?',
    leave_unsaved_warning: 'U verlaat deze pagina. Wilt u de wijzigingen opslaan?',
    loading: 'Laden ...',
    mailingAddress: 'Postadres',
    measurement: 'Afmeting',
    meter: 'meter',
    mobilePhone: 'Mobiele telefoon',
    name: 'Nom',
    no: 'Nee',
    notApplicable: 'Niet van toepassing',
    notApplicableAbbr: 'n.v.t.',
    number: 'Numéro',
    off: 'off',
    ok: 'OK',
    on: 'on',
    order: 'Commande',
    orders: 'Commandes',
    otherPrintClients: 'Overig',
    page: 'Page',
    password: 'Wachtwoord',
    phone: 'Telefoon',
    plannedWorkshopPrintClient: 'Atelier als gepland',
    postalCode: 'Postcode',
    prefix: 'Tussenvoegsel',
    price: 'Prijs',
    printers: 'Printers',
    priority: 'Prioriteit',
    productGroup: 'Groupe de produits',
    productType: 'Artikelsoort',
    publish: 'Publiceren',
    readMore: 'Lees meer ...',
    remark: 'Opmerking',
    remarks: 'Opmerkingen',
    required: 'Verplicht',
    returnOrder: 'Return order',
    save: 'Opslaan',
    saveClose: 'Opslaan & sluiten',
    saveNext: 'Opslaan & volgende',
    search: 'Zoek',
    selectPrinter: 'Selecteer bestemming voor printen',
    selectPrinterConfirm: 'Selecteer',
    send: 'Verzenden',
    series: 'Séries',
    service: 'Service',
    shipmentList: 'Shipment list',
    standard: 'Standaard',
    startDate: 'Begindatum',
    status: 'Status',
    stay: 'Blijf op pagina',
    stockLocations: 'Voorraadlocaties',
    stockUnit: 'Verpakkingseenheid',
    store: 'Vestiging',
    streetName: 'Straat',
    streetNumber: 'Huisnummer',
    success: 'Succes',
    supplier: 'Leverancier',
    switchOff: 'Uit',
    switchOn: 'Aan',
    tabDetails: 'Details',
    tabGeneral: 'Algemeen',
    taskstatus: 'Taakstatus',
    till: 'tot',
    title: 'Titel',
    to: 'Naar',
    total: 'Totaal',
    transport: 'Transport',
    type: 'Type',
    unit: 'Eenheid',
    username: 'Gebruikersnaam',
    value: 'Value',
    vatNumber: 'BTW-nummer',
    warning: 'Waarschuwing',
    week: 'Semaine',
    weeks: 'Weken',
    workshop: 'Atelier',
    workshopPrintClients: 'Ateliers',
    workshops: 'Workshops',
    yarn: 'Garen',
    year: 'Jaar',
    yes: 'Ja'
  },
  company: {
    administrationNumber: 'Administratienummer',
    clientSalesJournalCode: 'Verkoopdagboek klantfactuur',
    exact: 'Exact',
    exactServerName: 'Servernaam',
    fiscalUnit: 'Fiscale eenheid',
    intercompanySalesJournalCode: 'Verkoopdagboek intercompany factuur',
    intrastatReporting: 'Intrastat-rapportage',
    logo: 'Logo',
    purchaseJournalCode: 'Inkoopdagboek nummer',
    purchaseJournalType: 'Inkoopdagboek type',
    remarkInvoice: 'Opmerking factuur',
    salesJournalType: 'Verkoopdagboek type'
  },
  componentList: {
    amountReturn: 'Retour',
    extras: 'Suppléments',
    lined: 'Doublé',
    metersAmount: 'Nombre de mètres',
    panelsAmount: 'Nombre de panneaux',
    piecesAmount: 'Quantité',
    product: 'Produit',
    productType: 'Type de produit',
    romanBlindsAmount: 'Nombre de stores',
    total: 'Le total',
    totals: 'Totaux',
    unlined: 'Non doublé',
    weeks: 'Semaines'
  },
  configuration: {
    code: 'Code',
    fromDate: 'Valide à partir de',
    value: 'Valeur'
  },
  country: {
    eu: 'Europese Unie'
  },
  currency: {
    isoCode: 'ISO code',
    symbol: 'Symbool'
  },
  domain: {
    all: 'Mes domaines',
    apiKey: 'Clé API',
    barcodePrefix: 'Préfixe de code à barres',
    chooseDomain: 'Choisissez un domaine',
    company: 'Bedrijf',
    createFabrics: 'Stoffen aanmaken',
    culture: 'Culture',
    cultures: 'Cultures',
    deliveryPrice: 'Bezorgprijs',
    deliveryPrices: 'Bezorgprijzen',
    distributionCenter: 'Distributiecentrum',
    domainCode: 'Code domein',
    domainDescription: 'Omschrijving domein',
    export: 'Facturen exporteren via',
    familyOrderPacking: 'Family order packing',
    invalidFinishCombinations: 'Niet-toegestane afwerkingscombinaties',
    invoiceName: 'Naam op factuur',
    invoicePer: 'Factureren per',
    lastStockWorkshop: 'Ontvangend atelier uitlopende voorraad',
    nameOnTicket: 'Naam op bon',
    noData: 'Geen domeinen bekend',
    orderNumberPrefix: 'Ordernummer prefix',
    paymentDiscountPercentage: 'Betalingskorting (%)',
    paymentTermDays: 'Betalingstermijn (dagen)',
    priceDescription: 'Gekoppelde prijs',
    productGroup: 'Instellingen productgroep',
    productGroupFinishApplicable: 'Beschikbaar voor dit domein',
    productGroupFinishes: 'Domeinspecifieke afwerkingen',
    productGroupPrices: 'Prijzen',
    productGroupSettings: '{domainName} - Instellingen voor productgroep {productGroup}',
    rfidEnabledYN: 'RFID',
    rfidPrefix: 'RFID prefix',
    showOrdersInvoicePer: 'Showbanen factureren per',
    storeAttributes: 'Kenmerken vestiging',
    storeTypes: 'Vestigingstypes',
    stores: 'Vestigingen',
    stripCorrection: 'Stripcorrectie (banen)',
    tabContactPersons: 'Contactpersonen',
    tabGeneral: 'Algemeen',
    tabProducts: 'Artikelen',
    tabSettings: 'Instellingen',
    transportOrderMultipleWorkshops: 'Meerdere ateliers op verzendlijst'
  },
  draftTool: {
    black: 'Black',
    chrome: 'Chrome',
    electric: 'Electric',
    fixtureGrommets: 'Rings',
    fixturePole: 'Pole',
    fixtureRail: 'Rail',
    fixtureTabTop: 'Tab top',
    fixtureTunnelAtTop: 'Tunnel at top',
    fixtureTunnelAtTopAndBottom: 'Tunnel at top and bottom',
    fixtureWaveCurtain: 'Wave curtain',
    hemDouble: 'Double',
    hemNone: 'None',
    hemSingle: 'Single',
    left: 'Left',
    manual: 'Manual',
    piecesBoth: 'Two pieces',
    piecesLeft: 'Piece left',
    piecesRight: 'Piece right',
    pleatDouble: 'Double pleat',
    pleatDoubleReturn: 'Double with return pleat',
    pleatFlat: 'Flat pleat',
    pleatSingle: 'Single pleat',
    pleatSingleReturn: 'Single with return pleat',
    pleatTriple: 'Triple pleat',
    pleated: 'Pleated',
    pleatingTape: 'Pleating tape',
    productGroupCurtain: 'Panel curtain',
    productGroupLaces: 'Laces',
    productGroupRomanBlind: 'Roman blind',
    productGroupRoomHighCurtain: 'Ceiling-high curtain',
    productGroupTieBack: 'Tie-back',
    right: 'Right',
    setFromBottom: 'Set from bottom',
    setFromTop: 'Set from top',
    setNone: 'No set',
    tape: 'Tape',
    tbd: 'TBD',
    tieBackBanana: 'Banana',
    tieBackNone: 'None',
    tieBackStraight: 'Straight',
    tight: 'Tight',
    tunnelBack: 'Tunnel back',
    tunnelFront: 'Tunnel front',
    white: 'White'
  },
  error: {
    general_request: 'Er is iets fout gegaan. Probeer het later opnieuw.',
    oneOrMoreInputs: 'De gegevens kunnen niet worden opgeslagen want het formulier bevat fouten.',
    save: 'Er is iets fout gegaan. Probeer het later opnieuw.'
  },
  errorLog: {
    description:
      'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction',
    tips: 'Please click the bug icon in the upper right corner'
  },
  errorPages: {
    backToHome: "Retour à la page d'accueil",
    headline401: "Vous n'avez pas accès à cette page",
    headline403: "Vo'avez pas accès à cette page",
    headline404: 'Page non trouvée',
    message401: 'Indien u het hier niet mee eens bent, neem dan contact op met uw beheerder.',
    message403: 'Indien u het hier niet mee eens bent, neem dan contact op met uw beheerder.',
    message404: 'Controleer of de ingevoerde URL correct is.',
    return: 'Terug',
    title401: 'Oops',
    title403: 'Toegang geweigerd',
    title404: 'Sorry'
  },
  eventlog: {
    exception: 'Exception',
    level: 'Level',
    logger: 'Logger',
    message: 'Message',
    occurredAt: 'Datum tijd',
    thread: 'Thread'
  },
  exactInstance: {
    serverName: 'Server name',
    serviceUrl: 'Service URL'
  },
  fabric: {
    actualWidth: 'Largeur réelle (cm)',
    availableStock: 'Stock disponible',
    blackout: 'Rideaux occultants',
    canBeLined: 'peut être doublé',
    canBeUsedAsLiningForRomanBlindsYN: 'Convient pour la doublure de stores',
    canBeUsedAsLiningYN: 'Convient pour la doublure',
    canBeUsedForRomanBlinds: 'Convient aux stores',
    collections: 'Collections de tissus',
    consumerPrices: 'Prix ​​consommateur',
    containsWeightCord: 'A un cordon lesté',
    cordProduct: 'Corde',
    createdAt: 'Fait sur',
    cuttingWastePercentage: 'Perte de coupe (%)',
    description: 'Nom du tissu',
    discontinuationDate: 'Date expirée',
    domainProductCode: "Numéro de l'article",
    excludedWorkshops: 'Ateliers exclus',
    fabricStatusOption: 'Statut',
    flawInWeavingPercentage: 'Défaut de tissage de subdivision (%)',
    handlock: 'Serrure à main',
    hasPattern: 'Tissu à motifs',
    ironYN: 'Repasser',
    leftOverPercentage: 'Restante subdivision (%)',
    liningCordProduct: 'Corde au tissu comme doublure',
    lockSeamWidth: 'largeur de couture (cm)',
    nap: 'Poiles',
    noCordProductID: 'Inconnu',
    nonDiverseLinings: 'Doublure standard',
    partsPerHanger: 'Nombre maximum de pièces par centre',
    pattern: 'Motif',
    patternHeight: 'Hauteur du motif (mm)',
    posCode: 'Code POS',
    preferredWorkshop: 'Atelier préféré',
    prices: 'Des prix',
    productType: 'Type de tissu',
    purchasePrice: "Prix ​​d'achat",
    romanBlindCanBeLinedYN: 'Le store peut être doublé',
    romanBlindCode: 'Code de store',
    romanBlindRibTypeOption: 'Filons',
    sellingPrice: 'Prix ​​de vente',
    solid: 'Solide',
    sourceLinkDomainProductGroup: 'Domaine spécifique',
    sourceProductGroup: 'Groupe de produits',
    staggeredPatternYN: 'Motif décalé',
    stockCorrections: 'Les mutations',
    stocks: 'Stock disponible',
    tabDetails: 'Des détails',
    tabGeneral: 'Général',
    takeOverFromProductGroupToolTip: 'van {productGroupName} ({sourceName})',
    takeOverFromSettingsToolTip: 'van instellingen ({settingsName})',
    washingInstructionProduct: 'Instructions de lavage',
    weightCordProduct: 'Cordon lesté',
    weightPerM2InG: 'Poids au m2 (g)',
    width: 'Largeur (cm)',
    yarn: 'Fil'
  },
  fabricOrder: {
    actualDeliveryAt: 'Date de livraison réelle',
    createdAt: 'Date de création',
    deliveredQuantity: 'Livré (m)',
    domainName: 'Domaine',
    estimatedDeliveryAt: 'Date de livraison prévue',
    estimatedDepartureAt: 'Date de départ prévue',
    externallyModifiedAt: 'Modifié le',
    fabricOrderStatusOption: 'Statut',
    feedbackError: 'Manqué',
    feedbackOK: "d'accord",
    feedbackSuccessYN: 'Réaction',
    feedbackUndefined: '-',
    orderLines: 'Lignes de commande',
    orderNumber: 'Numéro de commande',
    orderedQuantity: 'Commandé (m)',
    plannedDeliveryAt: 'Date de livraison prévue',
    stockLocationName: 'Emplacement du stock',
    supplierCode: 'Numéro de fournisseur',
    supplierName: 'Fournisseur',
    tabGeneral: 'Général',
    totalDeliveredQuantity: 'Total livré (m)'
  },
  fabricStockReport: {
    availableStock: 'Libre',
    blockedStock: 'Bloqué',
    excelFileName: 'Voorraadoverzicht',
    excelWorksheetName: 'Voorraad',
    includeAvailableAmount: 'Beschikbare voorraad',
    includeBlockedAmount: 'Geblokkeerde voorraad',
    includePositionCode: 'Locatiecode',
    includeReservedAmount: 'Onderhanden werk',
    positionCode: 'Locatiecode',
    reservedStock: 'OHW',
    soldStock: 'Verkocht',
    stockLocations: 'Voorraadlocaties',
    stockReportData: 'Voorraadoverzicht',
    tabGeneral: 'Selectie gegevens',
    totalStock: 'Totaal'
  },
  fileUpload: {
    dragAndDropHtml: 'Zet hier een bestand neer of<br><em>klik hier om een bestand te selecteren</em>',
    uploadTip: 'Upload een bestand tot 2 MB'
  },
  finish: {
    applyPleatMachineCorrectionYN: 'Machine en laser correctie toepassen',
    canBeExcludedDueToFabricYN: 'Stofbeperkingen van toepassing',
    canBeExcludedDueToWorkshopYN: 'Atelierbeperkingen van toepassing',
    extraFabricHeightFormula: 'Formule extra stofhoogte',
    extraFabricWidthFormula: 'Formule extra stofbreedte',
    fabricWidthFactor: 'Stofbreedte factor',
    finishMeasurementFabricFactor: 'Factor op de afwerkingsmaat',
    headingHeight: 'Hoofdhoogte (cm)',
    hideQuantityOnTicket: 'Verberg aantal op bon',
    maximumFabricWidthFactor: 'Bovengrens stofbreedte factor',
    minimumFabricWidthFactor: 'Ondergrens stofbreedte factor',
    parityOption: 'Pariteit',
    quantityFormula: 'Formule voor aantal',
    roundOption: 'Afronding',
    seperateSeriesYN: 'Aparte serie'
  },
  finishType: {
    calculationMethod: 'Rekenwijze',
    extraFabricHeightApplicable: 'Extra stofhoogte van toepassing',
    extraFabricWidthApplicable: 'Extra stofbreedte van toepassing',
    fabricWidthFactorRequired: 'Stofbreedte factor vereist',
    finishes: 'Afwerkingen',
    measurementRequired: 'Afmeting vereist',
    requiredProductType: 'Benodigde artikelsoort'
  },
  forgotPassword: {
    description:
      'Vous pouvez réinitialiser votre mot de passe. Remplissez le formulaire ci-dessous pour recevoir les instructions par email.',
    done: 'Un e-mail a été envoyé à {email}. Suivez les instructions fournies ici',
    submit: 'Envoyer un e-mail',
    title: 'Mot de passe oublié'
  },
  hemaPendingProject: {
    customerDebtorCode: 'Customer debtor code',
    customerDeliveryCode: 'Customer delivery code',
    customerName: 'Customer name',
    prjDate: 'Project date',
    prjNumber: 'Project number',
    sentDate: 'Sent date'
  },
  home: {
    orderLineStatusSummary: 'APERÇU DU STATUT',
    quickSearch: 'RECHERCHE RAPIDE',
    welcomeVisitor: 'Bienvenue visiteur'
  },
  invalidFinishCombination: {
    finish1: 'Afwerking 1',
    finish2: 'Afwerking 2'
  },
  invoice: {
    clientName: 'Klant',
    details: 'Overzicht orders',
    exportAccountingAt: 'Verzonden finance',
    exportClientAt: 'Verzonden klant',
    externalInvoice: 'Externe factuur',
    internalInvoice: 'Interne factuur',
    invoiceDate: 'Factuurdatum',
    invoiceNumber: 'Factuurnr.',
    invoiceType: 'Factuurtype',
    invoicedInternallyYN: 'IC fact.',
    invoicesPrinted: 'De PDF(s) zijn aangemaakt',
    month: 'Maand',
    numberOfOrders: 'Bonnen',
    print: 'Printen',
    purchaseInvoiceExportedOn: 'IC inkoopfactuur naar Exact',
    salesInvoiceExportedOn: 'IC verkoopfactuur naar Exact',
    selectedInvoices: 'Facturen',
    storeCode: 'Vestiging',
    summary: 'Overzicht totalen',
    totalAmountExcludingVAT: 'Totaal excl. BTW',
    totalAmountIncludingVAT: 'Totaal incl. BTW',
    year: 'Jaar'
  },
  invoiceSummary: {
    create: 'Create invoice summary',
    from: 'From',
    to: 'to'
  },
  kwantum: {
    errorMessage: 'Error message',
    failedYN: 'Failed',
    m1_OrderNumberBuyer: 'M1 Order number buyer',
    m1_QueuedAt: 'M1 Processed on',
    m2_PolygonNumber: 'M2 Polygon number',
    m2_ProjectID: 'M2 Project ID',
    m2_PurchaseNumber: 'M2 Purchase number',
    m2_QueuedAt: 'M2 Processed on'
  },
  language: {
    code: 'ISO 639-1 Code'
  },
  linkPriceListItem: {
    blackoutYN: 'blackoutYN',
    extraCostYN: 'extraCoûtYN',
    finishesDescription: 'finitionsDescription',
    priceListItem: 'PriceListItem',
    priceListItemDescription: 'priceListItemDescription',
    selectedFinishes: 'sélectionnéFinitions'
  },
  login: {
    code: "Nom d'utilisateur",
    forbidden: 'La combinaison utilisateur/IP est bloquée.',
    logIn: 'Login',
    password: 'Mot de passe',
    title: 'Login',
    unauthorised: 'Ces informations de connexion sont incorrectes.'
  },
  mail: {
    bcc: 'Bcc',
    body: 'Bericht',
    cc: 'Cc',
    error: "Un problème est survenu. Votre email n'a pas été envoyé.",
    from: 'Van',
    subject: 'Onderwerp',
    success: 'Votre e-mail a été envoyé avec succès',
    to: 'Aan'
  },
  navbar: {
    dashboard: 'Dashboard',
    language: 'Langue',
    logOut: 'Se déconnecter',
    screenfull: 'Screenfull',
    size: 'Taille globale',
    theme: 'Theme'
  },
  newPassword: {
    description: 'U kunt nu uw wachtwoord permanent wijzigen.',
    done: 'Uw wachtwoord is gewijzigd.',
    invalidToken: 'Deze link is verlopen.',
    submit: 'Wijzig wachtwoord',
    title: 'Nieuw wachtwoord'
  },
  order: {
    clientName: 'Nom du client',
    consumerAddress: 'adresse du consommateur',
    consumerDetails: 'Klantgegevens',
    consumerName: 'Nom du client',
    createSamples: 'Samples aanmaken',
    createdAt: 'créé à',
    finish: 'Afronden',
    internalRemarks: 'Remarques internes',
    orderNumber: 'numéro de commande',
    orderStatus: 'statut de la commande',
    orderedAt: 'commandé à',
    source: 'La source',
    storeName: 'nom du magasin',
    type: 'taper'
  },
  orderDraftValidation: {
    bottomHem: 'Bottom hem is required.',
    bottomHemSize: 'Bottom hem size is required.',
    colorAndDiameter: 'Color & diameter are required.',
    fabric: 'Fabric is required.',
    fabricWidth: 'The required fabric height is greater than the width of the fabric.',
    fixture: 'Fixture is required.',
    height: 'Height is required.',
    hooks: 'Hooks is required.',
    hooksDistance: 'Distance runners is required.',
    operatingSide: 'Operating side is required.',
    pleat: 'Pleat is required',
    pleatFactorPanel: 'Pleating factor is out of bounds. Please change the number of panels.',
    pleatFactorRoomHigh: 'Pleating factor is out of bounds. Please change the cutting size.',
    productGroup: 'Product type is required.',
    railLength: 'Rail length is required',
    romanBlindFabricWidth: 'Requested height is incompatible with fabric width.',
    tieBackType: 'Type is required.',
    tunnelPercentage: 'Fabric on rod is required.',
    tunnelSize: 'Tunnel size is required.',
    width: 'Width is required.'
  },
  orderLine: {
    actualDeliveryDate: 'Date de livraison réelle',
    alignPatternYN: 'alignPatternYN ',
    amount: 'montant',
    assemblyHeight: "Hauteur d'assemblage",
    bandMeasurementInCm: 'Band (cm)',
    bottomFinish: 'finition du bas',
    bottomSeam: 'Onderzoom',
    chainProduct: 'chaîneProduit',
    confirmPrint: 'confirmerImprimer',
    consumerName: 'Nom du client',
    cordProduct: 'Cordon Produit',
    createNewPrice: 'créerNouveauPrix',
    createReturnOrder: 'createReturnOrder',
    customerReference: 'Référence de commande',
    customerRemarks: 'clientRemarques',
    cutSize: 'Taille de coupe',
    cutSizeLeft: 'Taille de coupe à gauche (cm)',
    cutSizeRight: 'Taille de coupe à droite (cm)',
    deliver: 'Livraison à domicile',
    delivery: 'Livraison',
    deliveryDate: 'Date de livraison',
    details: 'Des détails',
    discountPercentage: 'Rabais %',
    embraceForOrderNumber: 'Embrasse pour',
    embraceFromFinish: 'Le type',
    embraceFromOrderLine: 'Embrasse de',
    embraceFromOrderNumber: 'Embrasse de',
    embraceLengthLeft: 'Longueur gauche (cm)',
    embraceLengthRight: 'Longueur droite (cm)',
    equal: 'Gelijk',
    estimatedDeliveryDate: 'Date de livraison prévue',
    exceedance: 'Dépassement',
    fabricName: 'Nom du tissu',
    fabricWidth: 'Largeur du tissu (cm)',
    familyOrder: 'Commande familiale',
    familyOrderLines: 'Commandes',
    finishedWidth: 'Largeur finie (cm)',
    fixtureFinish: 'Confirmation',
    fromStatus: 'Du statut',
    generalFinish: 'Sous-groupe de produits',
    groupReference: 'Référence de groupe',
    groupTotal: 'Total du groupe',
    halfPanelFrom: 'Demi panneau de',
    halfPanelTo: 'Demi panneau à',
    headingHeight: 'Tête (cm)',
    height: 'Hauteur finie (cm)',
    highestInSet: 'Highest in set (cm)',
    length: 'Longueur (cm)',
    liningFabricProduct: 'Tissu pour doublure',
    metersAmountLeft: 'Mètres à gauche',
    metersAmountRight: 'Mètres à droite',
    numberOfCords: 'Nombre de cordons',
    numberOfHangers: 'Nombre de cintres',
    numberOfPanels: 'Nombre de panneaux',
    numberOfPanelsLeft: 'Panneaux gauche',
    numberOfPanelsRight: 'Panneaux droite',
    numberOfParcels: 'Nombre de colis',
    numberOfSupports: 'Nombre de supports de montage',
    operationSide: 'Un service',
    orderDate: 'Date de commande',
    orderLinePriceType: 'Type de prix',
    orderLineStatus: 'Statut',
    orderLineSubstatus: 'Sous-statut',
    orderLinesCancelledLastMonth: 'Commandes annulées depuis le mois dernier',
    panelCustomerInfo: 'Informations de client',
    panelFabricInfo: 'Info  du tissu',
    panelFinish: 'Finitions',
    panelGeneral: 'Général',
    panelLiningFabricInfo: 'Info de la doublure',
    panelStatus: 'Statut',
    parts: 'Delen',
    patternHeight: 'Hauteur du motif (mm)',
    pickUp: 'Emporter',
    pickUpStore: 'Afhaalvestiging',
    pleatFactor: 'Plooifactor',
    priceRestricted: 'Le prix ne peut pas être ajusté car la commande a déjà été facturée.',
    printProductionTicket: 'Imprimer les bons de commande',
    printStatusOption: "État de l'impression",
    printStatusOptionFailed: 'Manqué',
    printStatusOptionPrinted: 'Imprimé',
    printStatusOptionQueued: 'Dans la queue',
    product: 'Produit',
    productGroup: 'Type de produit',
    productionTicketPrinted: "Le bon de commande a été envoyé à l'imprimante",
    quantity: 'Nombre',
    railLength: 'Rail length (cm)',
    remarksOnTicket: 'Notes sur la réception',
    ribsEqual: 'Lot en haut',
    ribsSide: 'Ribs position',
    ribsType: 'Filons',
    ringProduct: 'Anneaux',
    room: 'Espace',
    selectShipmentListDate:
      "Sélectionnez une date pour voir une liste de numéros de commandes avec le statut d'envoi à cette date",
    seriesNumber: 'Numéro de série',
    shareHalfPanelWith: 'Partager le panneau avec',
    shareHangerWith: 'Partager le cintre avec',
    sharesHalfPanel: 'Partage un demi-travail avec cette commande',
    sharesHanger: 'Partage le cintre avec cette commande',
    shipmentListDate: 'Date de la liste',
    show: 'Show',
    status: 'Statut',
    storeName: 'Nom du magasin',
    systemRemarks: 'System notes',
    tabGeneral: 'Général',
    tabHistory: 'Histoire',
    tabPrices: 'le prix',
    takeLeftoverFabric: 'Prenez les restes de tissu',
    ticketNumber: 'Numéro de commande',
    ticketType: 'Type de commande',
    toShipmentList: 'Go to shipment list',
    toStatus: 'Au statut',
    topFinish: 'Finition en haut',
    topFinishHeight: 'Tête (cm)',
    totalAmount: 'Le total',
    totalFabricInCm: 'Tissu total (cm)',
    transportEAN: 'Numéro de transport',
    transportStatus: 'Statut de transport',
    unequal: 'Ongelijk',
    urgent: 'Urgent',
    useExistingPrice: 'Utiliser un prix existant',
    validationMessage: "Raison de l'échec",
    waveSize: "Longueur d'onde (cm)",
    weights: 'Loodjes',
    width: 'Largeur (cm)',
    widthLeft: 'Largeur gauche (cm)',
    widthRight: 'Largeur droite (cm)',
    workshop: 'Atelier'
  },
  orderLineStatus: {
    cancellationAllowed: 'Annuler',
    changable: 'Modifier',
    orderLineStatus: 'Statut principal',
    orderLineSubstatus: 'Sous-statut',
    removeFromSeries: 'Supprimer de la série',
    scanParameter: 'Paramètre de numérisation',
    settable: 'Attribuer',
    substatusOrder: 'Séquence',
    substatusOrderReserved: 'Ce numéro a été réservé'
  },
  orderLineStatusSummary: {
    fri: 'ven',
    mon: 'lun',
    sat: 'sam',
    sun: 'dim',
    thu: 'jeu',
    total: 'Le total',
    tue: 'mar',
    wed: 'mer'
  },
  orderPick: {
    comments: 'commentaires',
    location: 'emplacement',
    neededMeters: 'mètres nécessaires',
    pickListID: 'Numéro de liste',
    picked: 'Picked',
    pickedMeters: 'compteurs choisis',
    pickedNumberOfRolls: 'choisi nombre de rouleaux',
    prefill: 'Pick needed m',
    processPickedItems: 'Sauvegarder',
    productCode: "Numéro de l'article",
    productDescription: 'nom du tissu',
    selectAPickList: 'Entrez le numéro de liste',
    seriesNumbers: 'Numéros de série ',
    widthInCm: 'largeur',
    yarnNumber: 'numéro de fil'
  },
  parcelType: {
    alternativeParcelType: 'Alternatieve verpakkingseenheid',
    cuttingPackagesAndRoles: 'pakketten en rollen',
    hangers: 'hangers',
    maximumLengthInM: 'Maximum lengte (m)',
    maximumQuantity: 'Maximum aantal',
    maximumWeightInKg: 'Maximum gewicht (kg)',
    parcelTypeOption: 'Type verpakkingseenheid',
    romanBlindBoxes: 'dozen'
  },
  penalty: {
    handedOutAtUtc: 'Uitgedeeld op (UTC)',
    penaltyPoints: 'Strafpunten',
    penaltyType: 'Type'
  },
  permission: {
    AccessLog: "Journal d'accès",
    AppSetting: "Paramètres de l'application",
    Ban: 'Interdictions',
    Client: 'Clients',
    Collection: 'Livres de tissus',
    Company: 'Entreprises',
    Configuration: 'Paramètres',
    Country: 'Les pays',
    Culture: 'Des cultures',
    Currency: 'Devises',
    DeliveryReport: 'Leveringlijst',
    DeliveryTimeReport: 'Rapportage levertijd',
    Domain: 'Domaine',
    DomainUser: 'Domain accounts',
    EventLog: "Journal d'incidents",
    ExactInstance: 'Exact instances',
    ExternalApiUser: "Utilisateurs d'API externes",
    ExternalInvoice: 'Les factures',
    Fabric: 'Tissus',
    FabricOrder: 'Commandes de tissus',
    FabricReport: 'Fabric details',
    FabricStockReport: 'Aperçu des stocks',
    Finish: 'Finitions',
    FinishType: 'Finitions',
    GLAccount: 'Comptes du grand livre',
    HemaPendingProject: 'HEMA pending projects',
    InvoiceSummary: 'Invoice summaries',
    Language: 'Langues',
    LinkDomainDeliveryPrice: 'Prix ​​de livraison',
    LinkPriceListItem: "Lien d'élément de liste de prix",
    Option: "Listes d'options",
    Order: 'Commandes',
    OrderLinePrice: 'Prix ​​des lignes de commande',
    OrderLineStatus: 'Statuts de commande',
    OrderLineStatusSummary: "Tableau de bord de présentation de l'état",
    OrderPickList: 'Listes de préparation de commandes',
    OrderReport: 'Liste Datacom',
    OrderReportVolume: 'Banenlijst',
    ParcelType: "Unités d'emballage",
    Permission: 'Autorisations',
    PriceListItem: 'Articles de la liste de prix',
    PriceListItemPrice: 'Prix ​​des articles de la liste de prix',
    PriceListMatrix: 'Matrices des listes de prix',
    PrintTemplate: "Modèles d'impression",
    Printer: 'Imprimantes',
    PrinterClient: "Clients d'imprimante",
    Product: "des article'articles",
    ProductionPlanning: 'Créer des sélections',
    ProductionPlanningSeries: 'Série de production',
    ReasonStockCorrection: 'Raisons des ajustements de stock',
    ReturnCause: 'Causes de retour',
    ReturnReason: 'Types de retour',
    ReturnReasonCategory: 'Catégories de motif de retour',
    Role: 'Rouleau',
    Shipment: 'expédition',
    ShipmentListType: "Type de liste d'expédition",
    StandardUser: 'Utilisateurs standard',
    Stock: 'Stock',
    StockCorrection: "Ajustements d'inventaire",
    StockLocation: 'Emplacements des stocks',
    Store: 'Magasins',
    StoreAttribute: 'Caractéristiques du magasin',
    StoreFabric: 'Liste des tissus du magasins',
    StoreType: 'Types de magasin',
    StoreUser: 'Connexions pour les magasins',
    Supplier: 'Fournisseurs',
    TemplateImage: 'Icônes de réception',
    Translation: 'Traductions',
    TransportCompany: 'Entreprises de transport',
    TransportOrder: "Liste d'expédition",
    TransportRoute: 'Voies de transport',
    Truck: 'Véhicules',
    Unit: 'Unités',
    User: 'Utilisateurs',
    VatType: 'Types de TVA',
    Workshop: 'Ateliers',
    Yarn: 'Fil',
    execute: 'Exécuter',
    none: 'Non',
    pageIsReadonly: "Vous n'avez aucun droit de modifier les informations de cette page.",
    read: 'Lis',
    roles: 'Vos rôles',
    selectPlaceholder: "Choisissez le niveau d'accès",
    switchRoles: 'Changer de rôle',
    tabPermissions: 'Autorisations',
    tabTaskTypes: 'Types de tâches',
    write: 'Écrire'
  },
  pickrec: {
    chooseEntryFor: 'Selecteer "{caption}"',
    itemNotFound: "'{caption}'",
    suggestionsMayBeMore: 'Er zijn mogelijk meer zoekresulten',
    suggestionsRestCount: 'Er zijn {count} meer zoekresultaten'
  },
  planning: {
    alreadyPlanned: 'Binnen de huidige productieplanning is al een planning gemaakt voor deze productgroep.',
    amount: 'Aantal',
    basedOnOrderDate: 'Op orderdatum',
    capacity: 'Capaciteit',
    capacityRequired: 'Capaciteit is vereisd',
    capacityStep: 'Capaciteit invoeren',
    confirmYear: 'Start production planning for',
    considerStoreAttributes: 'Series op vestigingskenmerk',
    curtainsMeters: 'meters overgordijn',
    curtainsRoomHigh: 'Overgordijnen kamerhoog',
    cuttings: 'Coupage',
    distributionCenterAvailableAmountInMeters: 'Voorraad D.C. (m)',
    domainAvailableAmountInMeters: 'Voorraad totaal (m)',
    estimatedDeliveryDate: 'Verwachte leverdatum',
    excludeDiverseLining: 'Diverse voering uitsluiten',
    excludedFabricsWillBeIgnored: 'Excluded fabrics will be ignored (configured in the workshop)',
    excludedStores: 'Uitgesloten vestigingen',
    exportSelection: 'Exporteer selecties',
    fabricCode: 'Artikelnummer',
    fabricDescription: 'Stof',
    generate: 'Genereren',
    group: 'Groep',
    inefficientPlanning: 'Je gaat nu inefficiënt plannen',
    installationService: 'Installation service',
    makeCurrent: 'Start planning',
    makeSelection: 'Selectie maken',
    makeSeries: 'Series maken',
    meters: 'Meters',
    netCurtainsMeters: 'meters vitrage',
    netCurtainsRoomHigh: 'Vitrages kamerhoog',
    newProposalWithFilter: 'Nieuw voorstel met filter',
    noStock: 'Geen voorraad',
    oldestOrder: 'Oudste order',
    orderAmount: 'Aantal orders',
    orders: 'Aantal familieorders',
    ordersToPlan: 'Te plannen orders',
    panels: 'Banen',
    pieces: 'Stuks',
    plan: 'Plannen',
    planAgain: 'Nog een keer plannen',
    planningDateRange: 'Deze planning bevat orders tussen de volgende data',
    planningInProgress: 'Er is al een planning bezig in de week van ',
    preselectionMade: "Er is al een selectie bezig voor deze groep. Klik op 'plannen'",
    requiredCapacity: 'Benodigde capaciteit',
    requiredFabric: 'Benodigde stof (m)',
    reset: 'Reset groep',
    romanBlinds: 'Vouwgordijnen',
    selectionStep: 'Selecties maken',
    series: 'Serie',
    seriesNumber: 'Serienummer',
    seriesStep: 'Series maken',
    storeAttribute: 'Vestigingskenmerk',
    tabGeneral: 'Planning capaciteit',
    temporarySave: 'Tijdelijk opslaan',
    tickets: 'Bonnen',
    toPlan: 'Te plannen',
    total: 'Totaal',
    weekNumber: 'Weeknummer',
    workshopAvailableAmountInMeters: 'Voorraad atelier (m)',
    workshopID: 'Atelier',
    workshopOrder: '#',
    yarnDescription: 'Garen'
  },
  planningOption: {
    CurtainRoomHigh: 'Overgordijnen kamerhoog',
    CurtainRoomHighUnit: 'm',
    Cutting: 'Coupage',
    CuttingUnit: 'stuks',
    NetCurtainRoomHigh: 'Vitrages kamerhoog',
    NetCurtainRoomHighUnit: 'meter',
    Panel: 'Banen',
    PanelUnit: 'banen',
    RomanBlind: 'Vouwgordijnen',
    RomanBlindUnit: 'stuks',
    Tieback: 'Embrasses',
    TiebackUnit: 'stuks'
  },
  priceListItem: {
    descriptionInvoice: 'Factuurbeschrijving',
    descriptionInvoiceForeign: 'Factuurbeschrijving internationaal',
    externalOnlyYN: 'Op interne factuur',
    height: 'hoogte',
    intercompany: 'IC',
    laborPrice: 'Maakloon',
    markUpYN: 'Toeslag',
    matrixYN: 'Matrix',
    maximumLength: 'Maximumhoogte',
    maximumWidth: 'Maximumbreedte',
    minimumLength: 'Minimumhoogte',
    minimumWidth: 'Minimumbreedte',
    priceListItems: 'Prijslijstitems',
    productCode: 'Productcode',
    stepSizeLength: 'Stapgrootte hoogte',
    stepSizeWidth: 'Stapgrootte breedte',
    tabCountryMatrix: 'Prijsmatrix ateliers',
    tabGeneral: 'Algemeen',
    tabMatrix: 'Prijsmatrix',
    tabPrices: 'Prijslijst',
    unit: 'Eenheid',
    width: 'Breedte'
  },
  priceListItemPrice: {
    calculatePrices: 'Bereken prijzen',
    consumerPrice: 'Consumentprijs',
    consumerPrices: 'Consumentprijzen',
    currency: 'Valuta',
    laborPrice: 'Maakloon',
    priceType: 'Prijssoort',
    workshopPrices: 'Atelierprijzen'
  },
  printTemplate: {
    domains: 'Domeinen',
    productGroup: 'Productgroep',
    templateDocument: 'Bestandsnaam',
    versionNumber: 'Versie'
  },
  printer: {
    printProvider: 'Provider',
    statusOption: 'Status',
    statusReceivedAt: 'Status ontvangen op',
    statusText: 'Ontvangen status',
    typeOption: 'Printertype'
  },
  product: {
    measurementInMm: 'Maat (mm)',
    ownCode: 'Eigen code',
    ownProduct: 'Eigen product',
    printOnTicket: 'Toon op bon',
    stockItem: 'Voorraadartikel'
  },
  productGroup: {
    active: 'Actief',
    defaultFinishQuantityFormula: 'Standaard formule voor aantal (uit afwerking)',
    description: 'Beschrijving',
    finishTypes: 'Afwerkingssoorten',
    maximumFabricWidthInCm: 'Maximum stofbreedte ongevoerd (cm)',
    maximumHeightInCm: 'Maximum hoogte ongevoerd (cm)',
    maximumLinedFabricWidthInCm: 'Maximum stofbreedte gevoerd (cm)',
    maximumLinedHeightInCm: 'Maximum hoogte gevoerd (cm)',
    maximumLinedWidthInCm: 'Maximum breedte gevoerd (cm)',
    maximumNumberOfLinedPanels: 'Maximum aantal banen gevoerd',
    maximumNumberOfPanels: 'Maximum aantal banen ongevoerd',
    maximumWidthInCm: 'Maximum breedte ongevoerd (cm)',
    minimumHeightInCm: 'Minimum hoogte (cm)',
    minimumNumberOfPanels: 'Minimaal aantal banen',
    minimumWidthInCm: 'Minimum breedte (cm)',
    parcelType: 'Verpakkingseenheid',
    productGroupDescription: 'Beschrijving',
    productGroupTypeOption: 'Berekeningen volgens',
    productGroups: 'Productgroepen',
    shipmentListType: 'Type verzendlijst',
    tabPossibleFabricProductTypes: 'Mogelijke stoffen',
    tabPossibleFinishes: 'Mogelijke afwerkingen'
  },
  productType: {
    fabricTypeOption: 'Type de tissu',
    measurementRequiredYN: 'Maat verplicht',
    products: 'Artikelen'
  },
  reasonStockCorrection: {
    reasonStockCorrectionOption: 'Categorie'
  },
  report: {
    deliveryReport: 'Leveringlijst',
    export: 'Exporteer lijst',
    orderReport: 'Banenlijst'
  },
  request: {
    networkError: 'Het netwerk is op dit moment niet bereikbaar.'
  },
  return: {
    return: 'Retour',
    returnCause: 'Retouroorzaak',
    returnPriceListItem: 'Te koppelen prijs',
    returnReason: 'Retourreden',
    returnReasonCategory: 'Retourredencategorie',
    returnReasonCategoryCode: 'Rapportage nummer',
    returnReasonCharacter: 'Rapportage letter',
    returnReasons: 'Retourredenen',
    returnType: 'Retourtype'
  },
  route: {
    Table: 'Table',
    avatarUpload: 'Avatar Upload',
    clipboardDemo: 'Clipboard',
    complexTable: 'Complex Table',
    componentIndex: 'Introduction',
    componentMixin: 'Mixin',
    components: 'Components',
    countTo: 'CountTo',
    createClient: 'Klant aanmaken',
    createCollection: 'Stofboek aanmaken',
    createCompany: 'Bedrijf aanmaken',
    createContactPerson: 'Contactpersoon aanmaken',
    createCountry: 'Land aanmaken',
    createCulture: 'Culture aanmaken',
    createCurrency: 'Valuta aanmaken',
    createDomain: 'Domein aanmaken',
    createExactInstance: 'Create Exact instance',
    createExternalApiUser: 'Externe API gebruiker aanmaken',
    createFabric: 'Stof aanmaken',
    createFabricOrder: 'Stoforder aanmaken',
    createFabricOrderLine: 'Stoforderregel aanmaken',
    createFinish: 'Afwerking aanmaken',
    createFinishType: 'Afwerkingssoort aanmaken',
    createInvalidFinishCombination: 'Niet-toegestane afwerkingscombinatie aanmaken',
    createLanguage: 'Taal aanmaken',
    createLinkDomainDeliveryPrice: 'Bezorgprijs aanmaken',
    createLinkDomainProductGroup: 'Koppeling domein productgroep bewerken',
    createLinkDomainProductGroupFinish: 'Domeinspecifieke afwerking aanmaken',
    createLinkPriceListItem: 'Koppeling prijslijstitem aanmaken',
    createLinkReasonStockCorrectionDomain: 'Create domain link',
    createLinkStoreCollection: 'Stofboek toekennen',
    createOrder: 'Order aanmaken',
    createOrderLine: 'Order aanmaken',
    createOrderLinePrice: 'Orderregelprijs aanmaken',
    createOrderLineStatus: 'Order status aanmaken',
    createParcelType: 'Verpakkingseenheid aanmaken',
    createPriceListItem: 'Prijslijstitem aanmaken',
    createPriceListItemPrice: 'Prijslijstitem prijs aanmaken',
    createPriceListMatrix: 'Prijslijstmatrix aanmaken',
    createPrintTemplate: 'Template aanmaken',
    createPrinter: 'Printer aanmaken',
    createPrinterClient: 'Printer client aanmaken',
    createProduct: 'Artikel aanmaken',
    createProductGroup: 'Productgroep aanmaken',
    createProductType: 'Artikelsoort aanmaken',
    createProductionPlanning: 'Selectie aanmaken',
    createReasonStockCorrection: 'Reden voorraadcorrectie aanmaken',
    createReturnCause: 'Retouroorzaak aanmaken',
    createReturnReason: 'Retourreden aanmaken',
    createReturnReasonCategory: 'Retourredencategorie aanmaken',
    createRole: 'Rol aanmaken',
    createShipmentListType: 'Type verzendlijst aanmaken',
    createStandardUser: 'Gebruiker aanmaken',
    createStock: 'Voorraad aanmaken',
    createStockLocation: 'Voorraadlocatie aanmaken',
    createStore: 'Vestiging aanmaken',
    createStoreAttribute: 'Kenmerk aanmaken',
    createStoreType: 'Vestigingstype aanmaken',
    createSupplier: 'Leverancier aanmaken',
    createTemplateImage: 'Bonpictogram aanmaken',
    createTransportCompany: 'Transporteur aanmaken',
    createTransportRoute: 'Transportroute aanmaken',
    createTruck: 'Voertuig aanmaken',
    createUnit: 'Eenheid aanmaken',
    createUrgentSeries: 'Spoedserie aanmaken',
    createUser: 'Gebruiker aanmaken',
    createVatType: 'BTW-soort aanmaken',
    createVatTypeRate: 'BTW-tarief aanmaken',
    createWorkshop: 'Atelier aanmaken',
    createYarn: 'Garen aanmaken',
    createglAccount: 'Grootboekrekeningnummer aanmaken',
    customTreeTable: 'Custom TreeTable',
    dashboard: 'Dashboard',
    directivePermission: 'Directive Permission',
    documentation: 'Documentation',
    dragDialog: 'Drag Dialog',
    dragTable: 'Drag Table',
    dropzone: 'Dropzone',
    dynamicTable: 'Dynamic Table',
    editClient: 'Klant bewerken',
    editCollection: 'Stofboek bewerken',
    editCompany: 'Bedrijf bewerken',
    editConfiguration: 'Instelling bewerken',
    editContactPerson: 'Bewerk contactpersoon',
    editCountry: 'Land bewerken',
    editCulture: 'Culture bewerken',
    editCurrency: 'Valuta bewerken',
    editDomain: 'Domein bewerken',
    editExactInstance: 'Edit Exact instance',
    editExternalApiUser: 'Externe API gebruiker bewerken',
    editFabric: 'Stof bewerken',
    editFabricOrder: 'Bewerk stoforder',
    editFabricOrderLine: 'Stoforderregel bewerken',
    editFinish: 'Afwerking bewerken',
    editFinishType: 'Afwerkingssoort bewerken',
    editInvalidFinishCombination: 'Niet-toegestane afwerkingscombinatie bewerken',
    editLanguage: 'Taal bewerken',
    editLinkDomainDeliveryPrice: 'Bezorgprijs bewerken',
    editLinkDomainProductGroup: 'Koppeling domein productgroep bewerken',
    editLinkDomainProductGroupFinish: 'Bewerk domeinspecifieke afwerking',
    editLinkPriceListItem: 'Koppeling prijslijstitem bewerken',
    editLinkReasonStockCorrectionDomain: 'Edit domain link',
    editLinkStoreCollection: 'Stofboek toekennen',
    editOrder: 'Order bewerken',
    editOrderLine: 'Order bewerken',
    editOrderLinePrice: 'Orderregelprijs bewerken',
    editOrderLineStatus: 'Order status bewerken',
    editOrderPickList: 'Modifier liste order pick',
    editParcelType: 'Verpakkingseenheid bewerken',
    editPriceListItem: 'Prijslijstitem bewerken',
    editPriceListItemPrice: 'Prijslijstitem prijs bewerken',
    editPriceListMatrix: 'Prijslijstmatrix bewerken',
    editPrintTemplate: 'Template bewerken',
    editPrinter: 'Printer bewerken',
    editPrinterClient: 'Printer client bewerken',
    editProduct: 'Artikel bewerken',
    editProductGroup: 'Productgroep bewerken',
    editProductType: 'Artikelsoort bewerken',
    editProductionPlanning: 'Selectie bewerken',
    editReasonStockCorrection: 'Reden voorraadcorrectie bewerken',
    editReturnCause: 'Retouroorzaak bewerken',
    editReturnReason: 'Retourreden bewerken',
    editReturnReasonCategory: 'Retourredencategorie bewerken',
    editRole: 'Rol bewerken',
    editShipmentListType: 'Type verzendlijst bewerken',
    editStandardUser: 'Edit user',
    editStock: 'Voorraad bewerken',
    editStockLocation: 'Voorraadlocatie bewerken',
    editStore: 'Vestiging bewerken',
    editStoreAttribute: 'Kenmerk bewerken',
    editStoreType: 'Vestigingstype bewerken',
    editStoreUser: 'Gebruiker bewerken',
    editSupplier: 'Leverancier bewerken',
    editTemplateImage: 'Bewerk bonpictogram',
    editTranslation: 'Vertaling bewerken',
    editTransportCompany: 'Transporteur bewerken',
    editTransportOrder: 'Verzendlijst bewerken',
    editTransportRoute: 'Transportroute bewerken',
    editTruck: 'Voertuig bewerken',
    editUnit: 'Eenheid bewerken',
    editUser: 'Gebruiker bewerken',
    editVatType: 'BTW-soort bewerken',
    editVatTypeRate: 'BTW-tarief bewerken',
    editWorkshop: 'Atelier bewerken',
    editYarn: 'Garen bewerken',
    editglAccount: 'Grootboekrekeningnummer bewerken',
    errorLog: 'Error Log',
    errorPages: 'Error Pages',
    example: 'Example',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    exportZip: 'Export Zip',
    externalLink: 'External Link',
    form: 'Form',
    guide: 'Guide',
    home: 'Home',
    i18n: 'I18n',
    icons: 'Icons',
    inlineEditTable: 'Inline Edit',
    introduction: 'Introduction',
    jsonEditor: 'JSON Editor',
    markdown: 'Markdown',
    menu_admin: 'Administrateur',
    menu_admin_accesslog: "Journal d'accès",
    menu_admin_application: 'Application',
    menu_admin_appsettings: "Paramètres d'application",
    menu_admin_bans: 'Interdictions',
    menu_admin_collections: 'Collections de tissus',
    menu_admin_company_structure: "Structure de l'entreprise",
    menu_admin_configuration: 'Paramètres',
    menu_admin_countries: 'Les pays',
    menu_admin_eventlog: 'Journal des événements',
    menu_admin_exact_instances: 'Exact instances',
    menu_admin_external_api_users: 'Connexions API externes',
    menu_admin_fabric_order: 'Commandes de tissus',
    menu_admin_fabrics: 'Liste de tissus',
    menu_admin_finishtypes: 'Finitions',
    menu_admin_invoicing: 'Facturation',
    menu_admin_languages: 'Langues',
    menu_admin_masterdata: 'Donnee de base',
    menu_admin_options: 'Listes de sélection',
    menu_admin_ordering_api_users: 'Commander des connexions API',
    menu_admin_penalties: 'Pénalités',
    menu_admin_pricing: 'Tarifs',
    menu_admin_printtemplates: 'Modèles de bons de commande',
    menu_admin_productgroups: 'Groupes de produits',
    menu_admin_production: 'Production',
    menu_admin_products: 'Des articles',
    menu_admin_producttypes: 'Des articles',
    menu_admin_reasonstockcorrections: 'Raisons des corrections de stock',
    menu_admin_roles: 'Rouleau',
    menu_admin_store_users: 'Magasins',
    menu_admin_templateimages: 'Icônes de reçu',
    menu_admin_translations: 'Traductions',
    menu_admin_transport: 'Transport',
    menu_admin_units: 'Unités',
    menu_admin_users: 'Utilisateurs',
    menu_admin_vattypes: 'Types de TVA',
    menu_admin_yarns: 'Fil',
    menu_client_management: 'Gestion de la clientèle',
    menu_client_sales_report: 'Omzetlijst',
    menu_clients: 'Clients',
    menu_companies: 'Entreprises',
    menu_component_list: 'Liste des composants',
    menu_cultures: 'Des cultures',
    menu_currencies: 'Devises',
    menu_delivery_report: 'Leveringlijst',
    menu_domains: 'Domaines',
    menu_external_invoices: 'Factures externes',
    menu_fabric_management: 'Tissus',
    menu_fabric_report: 'Fabric details',
    menu_fabric_stockcorrections: 'Correction boursière',
    menu_fabric_stockreport: 'Aperçu des stocks',
    menu_hema: 'HEMA',
    menu_internal_invoices: 'Factures internes',
    menu_invoice_summary: 'Résumé de la facture',
    menu_invoicing: 'Facturation',
    menu_link_domain_delivery_prices: 'Tarifs de livraison',
    menu_link_price_list_items: 'Lien des articles de la liste de prix',
    menu_order_handling: 'Commandes',
    menu_order_line_prices: 'Prix ​​de la ligne de commande',
    menu_order_line_statuses: 'Statuts de commande',
    menu_order_pick_list: 'Créer liste order pick',
    menu_order_pick_list_complete: 'Liste order pick envoyée',
    menu_order_report: 'Liste datacom',
    menu_order_report_volume: 'Banenlijst',
    menu_orderlines: 'Commandes',
    menu_orders: 'liste de commande',
    menu_parcel_types: "Unités d'emballage",
    menu_planning: 'Planification',
    menu_price_list_item_prices: 'Prix ​​des articles de la liste de prix',
    menu_price_list_items: 'Articles de la liste de prix',
    menu_price_list_matrices: 'Matrices tarifaires',
    menu_printer_clients: 'Imprimante cliente',
    menu_production_planning: 'Sélection',
    menu_reports: 'Signaler',
    menu_return_causes: 'Causes de retour',
    menu_return_type_categories: 'Motifs de retour',
    menu_return_types: 'Types de retour',
    menu_series: 'Séries',
    menu_shipment_list_types: "Liste d'expédition",
    menu_show_orders: 'Show samples',
    menu_status_list: 'Liste des statuts',
    menu_store: 'Branche',
    menu_store_fabrics: 'Tissus',
    menu_store_orders: 'Commandes',
    menu_store_shipment_list: "Liste d'expédition",
    menu_stores: 'Emplacements',
    menu_suppliers: 'Fournisseurs',
    menu_transport: 'Transport',
    menu_transport_companies: 'Transporteurs',
    menu_transport_list: "Listes d'expédition",
    menu_transport_planning: "Créer liste d'expédition",
    menu_transport_routes: 'Itinéraires de transport',
    menu_trucks: 'Véhicules',
    menu_workshops: 'Ateliers',
    page401: '401',
    page403: '403',
    page404: '404',
    pagePermission: 'Page Permission',
    permission: 'Permission',
    selectExcel: 'Export Selected',
    splitPane: 'SplitPane',
    sticky: 'Sticky',
    tab: 'Tab',
    theme: 'Theme',
    tinymce: 'Tinymce',
    treeTable: 'Tree Table',
    uploadExcel: 'Upload Excel',
    userSettings: 'Paramètres utilisateur',
    zip: 'Zip'
  },
  series: {
    addOrderNumbers: 'Ajouter des numéros de commande',
    amount: 'Nombre',
    amountOfEmbraces: 'Embrasse',
    amountOfHangers: 'Nombre de cintres',
    amountOfOrderLines: 'Commandes',
    amountOfOrders: 'Commande familiale',
    amountOfParcels: 'Emballage',
    amountOfRings: 'Anneaux',
    amountOfWaves: 'Plis ondulés',
    bulkActionLabel: 'Modifier les commandes sélectionnées',
    confirmDelete: 'Voulez-vous vraiment supprimer les commandes sélectionnées de la série?',
    confirmPrint: 'Voulez-vous vraiment imprimer les reçus sélectionnés?',
    confirmUpdate: 'Voulez-vous vraiment mettre à jour les commandes sélectionnées?',
    domainName: 'Domaine',
    doubleOrderNumber: 'Numéro de commande double',
    numberOfMeters: 'Nombre de mètres',
    numberOfPanels: 'Nombre de panneaux',
    orderNumbersAdded: 'Les numéros de commande ont été ajoutés',
    orderNumbersNotAdded: "Les numéros de commande n'ont pas pu être ajoutés",
    pieces: 'Pcs',
    printTickets: 'Imprimer les bons de commande',
    quantity: 'Quantité',
    series: 'Séries',
    seriesDescription: 'Séries',
    seriesNumber: 'Numéro de série',
    seriesPrintError: "Tous les reçus n'ont pas pu être imprimés",
    seriesPrintStart: '{toBePrintedCount} Les reçus de cette série sont imprimés',
    seriesPrintSuccess: 'Les bons de commandes ont été envoyés à {printDestination}',
    seriesStatus: 'Statut',
    ticketsAlreadyPrintedCancel: 'Oui, tout réimprimer',
    ticketsAlreadyPrintedConfirm: 'Non, juste les nouvelles impressions',
    ticketsAlreadyPrintedMessage:
      '{PrintedTickets} des reçus de {totalTickets} ont déjà été imprimés. Voulez-vous le réimprimer?',
    ticketsAlreadyPrintedTitle: 'Avertissement',
    typeOfOrders: 'Types de commandes',
    unit: 'Unité',
    updateOrderLines: 'Mise à jour',
    weekNumber: 'Semaine',
    workshopName: 'Atelier'
  },
  size: {
    medium: 'La norme',
    mini: 'Le plus petit',
    small: 'Petite'
  },
  statusList: {
    allOrders: 'Tous les commandes',
    fabricCode: "Numéro de l'article",
    fabricName: 'Nom du tissu',
    hangers: 'Cintres',
    notScanned: 'Non scanné',
    scanned: 'Scanné',
    seriesNumber: 'Numéro de série',
    seriesPlaceholder: 'Numéros de série [1-5,7,10-12]',
    status: 'Statut',
    storeCode: 'numéro de magasin',
    storeName: 'nom du magasin',
    subStatus: 'Sous-statut',
    ticketNumber: 'Numéro de commande'
  },
  stock: {
    mutatedAt: 'Date de réservation',
    mutationInMeters: 'Nombre de mètres',
    mutationReason: 'Raison',
    onlyShowFabricsWithAvailableStock: 'Afficher uniquement les tissus dont le stock est disponible',
    positionCode: "Code d'emplacement",
    stockAvailable: 'Stock disponible (m)',
    stockBlocked: 'Stock bloqué (m)',
    stockLocationName: 'Emplacement du stock',
    stockReserved: 'Travaux en cours (m)',
    stockSold: 'Stock vendu (m)'
  },
  stockCorrection: {
    availableAmount: 'Stock disponible (m)',
    chooseReasonStockCorrection: "Raison de l'ajustement des stocks",
    clearInput: "Effacer l'entrée",
    clearInputSuggestion: 'Traitez ou supprimez vos entrées pour changer de liste de stock',
    clearInputWarning: 'Toutes vos entrées seront supprimées',
    correction: 'Correction (m)',
    createdAt: 'Date de réservation',
    mutation: 'Mutation du tissus',
    processStockCorrection: "Traiter les ajustements d'inventaire",
    reason: 'Raison',
    reasonRequired: 'Une raison est obligatoire',
    remarks: 'Noter',
    saveSelection: 'Sauvegarder la correction',
    selectAStockLocation: 'Sélectionnez un emplacement de stock',
    stockLocationName: 'Emplacement du stock',
    stockProductCode: "Numéro de l'article",
    stockProductDescription: 'Tissu'
  },
  store: {
    attribute: 'Kenmerk',
    code: 'Numéro de magasin',
    collection: 'Stofboek',
    domain: 'Domaine',
    height: 'Hoogte (cm)',
    name: 'Nom du magasin',
    tabContactPersons: 'Contactpersonen',
    tabGeneral: 'Algemeen',
    tabSettings: 'Instellingen',
    tabStoreCollections: 'Stofboeken',
    type: 'Type'
  },
  storeFabric: {
    availableStockInM: 'Stock (m)',
    estimatedNewStock: 'Nouveau stock attendu',
    soldStockInM: 'Vendu (m)'
  },
  storeUser: {
    clientName: 'Client',
    storeCode: 'numéro de magasin',
    storeName: 'Magasin'
  },
  supplier: {
    agentName: 'Naam agent',
    code: 'Leveranciersnummer',
    domain: 'Domaine',
    tabContactPersons: 'Contactpersonen',
    tabGeneral: 'Algemeen'
  },
  table: {
    actions: 'Actions',
    searchDatePlaceholder: 'Tapez ou sélectionnez',
    searchPlaceholder: 'Tapez pour rechercher',
    searchSelectPlaceholder: 'Sélectionnez pour rechercher',
    withRestriction: 'Met beperking'
  },
  tagsView: {
    close: 'Sluiten',
    closeAll: 'Alle sluiten',
    closeOthers: 'Andere sluiten',
    refresh: 'Verversen'
  },
  templateImage: {
    templateDocument: 'Afbeelding (png)',
    templateImageTypeOption: 'Type pictogram'
  },
  translation: {
    code: 'Vertalingcode'
  },
  transport: {
    loadingAddress: 'Laadadres',
    loadingAddressCode: 'Code laadadres',
    loadingTimeRange: 'Laadtijden (van, tot)',
    shipperNumber: 'Verladernummer winkelbezorging',
    shipperNumberHomeDelivery: 'Verladernummer thuisbezorging',
    transportCompany: 'Transporteur',
    unloadingAddressCode: 'Code losadres',
    unloadingTimeRange: 'Lostijden (van, tot)'
  },
  transportOrder: {
    confirmAlreadyExportedExport: "Cette liste d'expédition a déjà été envoyée. Voulez-vous le renvoyer?",
    confirmExport: "Voulez-vous envoyer cette liste d'expédition à la compagnie de transport?",
    countryCode: 'Pays',
    createShipments: "Créer des listes d'expédition",
    domainOrderNumberPrefix: 'Domaine',
    exportShipments: 'expédier',
    exportedAt: "Liste d'expédition envoyée",
    exportedTo: 'Naar',
    fromDate: 'Commandes de',
    hangers: 'Cintres',
    isExcluded: 'Ne sera pas expédié',
    isIncluded: 'Être envoyé',
    parcels: 'Centres / paquets',
    planningDateRange: 'Cette liste contient les commandes scannées entre les dates suivantes',
    reference: 'Référence',
    scannedAt: 'Scanné à',
    seriesNumber: 'Numéro de série',
    shipmentAt: 'Temps de transport',
    shipmentListTypeName: "Type de liste d'expédition",
    shipments: 'Les expéditions',
    shipmentsCreated: "Les listes d'expédition ont été créées",
    shipmentsExportError: "La liste d'expédition n'a pas pu être envoyée à la compagnie de transport",
    shipmentsExported: "La liste d'expédition a été envoyée à la compagnie de transport",
    status: 'Statut',
    storeAttribute: 'Référence du magasin',
    storeCode: 'numéro de magasin',
    subStatus: 'Sous-statut',
    ticketNumber: 'Numéro de commande',
    truckIdentifier: 'Véhicule',
    untilDate: "Commandes jusqu'à",
    workshops: 'Workshop(s)'
  },
  transportRoute: {
    code: 'Routecode',
    countryCode: 'Land',
    postalCodeFrom: 'Postcode van',
    postalCodeTo: 'Postcode tot'
  },
  unit: {
    meters: 'mètres',
    panels: 'panneaux',
    pieces: 'pcs'
  },
  user: {
    avatar: 'Image de profil',
    avatarInfo: "URL vers l'image de profil",
    newPassword: 'Nouveau mot de passe',
    newPasswordInfo: 'Laissez ce champ vide si vous ne souhaitez pas modifier votre mot de passe',
    oldPassword: 'Mot de passe actuel',
    oldPasswordInfo: 'Entrez votre mot de passe actuel pour vérifier',
    oldPasswordInvalid: "Vous n'avez pas entré le mot de passe actuel correct",
    passwordChanged: 'votre mot de passe a été changé',
    repeatPassword: 'Répéter le mot de passe',
    repeatPasswordInfo: 'Répétez votre nouveau mot de passe pour vérifier',
    roles: 'Rouleau',
    workingAt: 'Travailler à'
  },
  validation: {
    cannotExcludePreferredWorkshop: 'Het voorkeursatelier kan niet worden uitgesloten',
    complexity: 'Kies complexiteit',
    ean: 'Deze barcode is incorrect',
    email: 'Dit is een ongeldig e-mailadres',
    error: {
      alphanumeric: 'Minstens 1 symbool is vereist',
      digit: 'Minstens 1 getal is vereist',
      invalidFormula: 'Eén of meerdere formules bevat een fout: {errorMessage}',
      isFromDatabase: 'Het wachtwoord kan niet worden gevalideerd, omdat de server niet bereikbaar is.',
      itemNotFound: 'Bestand is reeds verwijderd.',
      length: 'Minstens {count} karakters zijn vereist',
      lowercase: 'Minstens 1 kleine letter is vereist',
      passwordComplexity: 'Het wachtwoord voldoet niet aan de vereiste complexiteit',
      uppercase: 'Minstens 1 hoofdletter is vereist'
    },
    formValidationFailed: 'Dit formulier bevat fouten. Controleer uw invoer en probeer het opnieuw',
    notAllWorkshopsCanBeExcluded: 'Er moet tenminste 1 atelier beschikbaar zijn',
    numeric: 'Alleen cijfers toegestaan',
    oldPasswordRequired: 'Vul het oude wachtwoord in',
    repeatPasswordMismatch: 'Twee wachtwoorden komen niet overeen',
    required: 'Dit veld is vereist'
  },
  vat: {
    countryCode: 'Land',
    countryID: 'Land',
    glCodePurchase: 'Btw-code inkoop',
    glCodeSales: 'Btw-code verkoop',
    invoiceText: 'Tekst op factuur',
    rates: 'Tarieven',
    startDate: 'Ingangsdatum',
    taxCategoryCode: 'UNECE code',
    vatNumber: 'BTW-nummer',
    vatNumberRequiredYN: 'BTW-nummer verplicht',
    vatPercentage: 'Tarief (%)',
    vatType: 'BTW-soort',
    vatTypeOption: 'Type'
  },
  wizard: {
    next: 'suivante',
    prev: 'Précédent',
    skip: 'Ignorer',
    skipnexttwo: 'Passer (2)'
  },
  workshop: {
    code: 'Workshop number',
    excludeExpressOrderYN: 'Uitsluiten van spoedorders',
    excludeHandlockYN: 'Uitsluiten van handlock',
    excludeSamplesYN: ' Uitsluiten van showbanen',
    ignoreExcludedFabrics: 'Ignore excluded fabrics',
    maximumProcessingHeight: 'Maximale verwerkingshoogte (cm)',
    metersMaxPerSeries: 'Meters per serie',
    panelsMaxPerSeries: 'Banen per serie',
    romanBlindsMaxPerSeries: 'Vouwgordijnen per serie',
    stockLocationName: 'Naam voorraadlocatie'
  },
  yarn: {
    planningOrder: 'Planningsvolgorde'
  }
};
